import { cn } from "@/common/helpers/utils";
import * as React from "react";

export interface ContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Whether the container should have a backdrop blur effect */
  backdrop?: boolean;
  /** Whether the container should have a border */
  border?: boolean;
  /** Variant of the container */
  variant?: "default" | "glass" | "solid";
  /** Size padding variant */
  size?: "sm" | "md" | "lg";
}

export function Container({
  className,
  backdrop = false,
  border = true,
  variant = "default",
  size = "md",
  children,
  ...props
}: ContainerProps) {
  const baseStyles = "rounded-2xl";

  const variantStyles = {
    default: "bg-background",
    glass: "backdrop-blur-sm bg-background/50",
    solid: "bg-card",
  };

  const sizeStyles = {
    sm: "p-4",
    md: "p-6 sm:p-8",
    lg: "p-8 sm:p-12",
  };

  const borderStyles = border ? "border border-border" : "";
  const backdropStyles = backdrop ? "backdrop-blur-sm" : "";

  return (
    <div
      className={cn(baseStyles, variantStyles[variant], sizeStyles[size], borderStyles, backdropStyles, className)}
      {...props}
    >
      {children}
    </div>
  );
}
